import { Box, Drawer, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LanguageIcon from '@mui/icons-material/Language';
import { deprecatedColors } from 'styles/theme/deprecatedColors';
import LanguageSelector from './components/LanguageSelector';

type MainMenuProps = {
    toggleDrawer: () => void;
    isOpen: boolean;
    children: React.ReactNode;
    hideLanguageSelector?: boolean;
};

export function MainMenuDrawer({ children, toggleDrawer, isOpen, hideLanguageSelector }: MainMenuProps) {
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    key="button"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ marginRight: 2 }}
                    onClick={toggleDrawer}
                >
                    <MenuIcon />
                </IconButton>
            </Box>
            <Drawer
                open={isOpen}
                anchor="left"
                PaperProps={{ sx: { maxWidth: '90vw', width: 375, padding: 2 } }}
                onClose={toggleDrawer}
            >
                <Box px={1} sx={{ display: 'flex', flexDirection: 'column', rowGap: 1 }}>
                    <Box display="flex" flexDirection="row" justifyContent="space-between">
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            onClick={toggleDrawer}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Box display="flex" alignItems="center">
                            {!hideLanguageSelector ? (
                                <LanguageSelector
                                    icon={<LanguageIcon style={{ color: deprecatedColors.secondary3, fontSize: 24 }} />}
                                />
                            ) : null}
                        </Box>
                    </Box>
                    {children}
                </Box>
            </Drawer>
        </>
    );
}
